import { LitElement, html, css } from 'lit'
import { triggerKlaviyoForm } from '../../lib/utils.js'
export class AddButton extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }
    `,
  ]

  static properties = {
    variantId: { type: Number, attribute: 'data-variant-id' },
    variantName: { type: String, attribute: 'data-variant-name' },
    productId: { type: Number, attribute: 'data-product-id' },
    quantity: { type: Number, attribute: 'quantity' },
    selling_plan: { type: Number, attribute: 'data-selling-plan-id' },
    disableCartToggle: { type: Boolean, attribute: 'disable-cart-toggle' },
    type: { type: String, attribute: 'type' },
    parentVariantId: { type: Number, attribute: 'data-parent-variant-id' },
    parentKey: { type: String, attribute: 'data-parent-key' },
    productHandle: { type: String, attribute: 'data-product-handle' },
    swap: { type: Boolean, attribute: 'swap' },
    outOfStock: { type: Boolean, attribute: 'out-of-stock' },
    klaviyoFormId: { type: String, attribute: 'klaviyo-form-id' },
    upsellSellingPlanId: { type: Number, attribute: 'data-upsell-selling-plan-id' },
    upsellVariantId: { type: Number, attribute: 'data-upsell-variant-id' },
    threeMonthUpsell: { type: String, attribute: 'data-three-month-upsell' },
    threeMonthSellingPlanId: { type: Number, attribute: 'data-three-month-upsell-selling-plan-id' },
  }

  constructor() {
    super()
    this.quantity = this.quantity ?? 1
    this.variantId = this.variantId ?? null
    this.productId = this.productId ?? null
    this.productHandle = this.productHandle ?? null
    this.selling_plan = this.selling_plan ?? null
    this.disableCartToggle = this.disableCartToggle ?? false
    this.type = this.type ?? 'main'
    this.parentVariantId = this.parentVariantId ?? null
    this.parentKey = this.parentKey ?? null
    this.swap = this.swap ? true : false
    this.outOfStock = this.outOfStock ?? false
    this.klaviyoFormId = this.klaviyoFormId ?? null
    this.upsellSellingPlanId = this.upsellSellingPlanId ?? null
    this.upsellVariantId = this.upsellVariantId ?? null
    this.threeMonthUpsell = this.threeMonthUpsell ?? null
    this.threeMonthSellingPlanId = this.threeMonthSellingPlanId ?? null
  }

  connectedCallback() {
    super.connectedCallback()
  }

  renderButton() {
    return html` <slot @click=${this._onClick}> </slot>`
  }
  render() {
    return html` ${this.renderButton()} `
  }

  _onClick(e) {
    if (this.outOfStock) {
      triggerKlaviyoForm(this.klaviyoFormId)
      return
    }

    let data = {
      variant_id: this.variantId,
      quantity: this.quantity,
      toggle_side_cart: this.toggle_side_cart,
      parent_key: this.parentKey,
      disableCartToggle: this.disableCartToggle,
      properties: {
        _upsell_selling_plan_id: this.upsellSellingPlanId,
        _upsell_variant_id: this.upsellVariantId,
        _three_month_selling_plan_id: this.threeMonthSellingPlanId,
      },
    }

    if (this.selling_plan) {
      data.selling_plan = this.selling_plan
    }

    if (this.type === 'cart-upsell' && window?.gtag) {
      window.gtag('event', 'Side Cart - Upsell Added', {
        event_detail: this.variantId,
        event_detail2: this.productHandle,
      })
    }

    if (this.type === 'cart-subscription-upsell' && window?.gtag) {
      window.gtag('event', `Side Cart - ${this.threeMonthUpsell === 'true' ? 'Three' : 'One'} Subscription Upsell Added`, {
        event_detail: this.variantId,
        event_detail2: this.productHandle,
      })
      window.MicroBus.emit('igEvents:push', {
        event: `Side Cart - ${this.threeMonthUpsell === 'true' ? 'Three' : 'One'} Month Subscription Upsell Added - ${
          this.productHandle
        }`,
      })
    }

    if (this.type === 'sticky-atc' && window?.gtag) {
      window.gtag('event', 'Sticky Add To Cart - Clicked', {
        event_detail: this.variantId,
      })
    }

    if (this.type === 'interstitial' && window?.gtag) {
      window.gtag('event', 'Interstitial - Add To Cart', {
        event_detail: this.variantId,
        event_detail2: `Parent Variant - ${this.parentVariantId}`,
      })
    }

    if (this.type === 'interstitial') {
      window.MicroBus.emit('igEvents:push', {
        event: `Interstitial Upsell ATC - ${this.variantName}`,
      })
    }

    if (this.type === 'main') {
      window.MicroBus?.emit('igEvents:push', {
        event: `Add to Cart - ${window.allVariants?.find((variant) => variant.id == this.variantId)?.name}`,
      })
    }

    if (this.swap && this.parentKey) {
      window.MicroBus.emit('cart:swap', data)
    } else {
      console.log('cart:add', data)
      window.MicroBus.emit('cart:add', data)
    }
    e.preventDefault()
  }
}
customElements.define('add-button', AddButton)
